import { Configuration, PublicClientApplication } from '@azure/msal-browser';

const msalConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID || '',
    redirectUri: `${window.location.origin}/auth`,
    postLogoutRedirectUri: `${window.location.origin}/msallogoutsuccess`,
    authority: 'https://login.microsoftonline.com/common',
  },
  cache: {
    cacheLocation: 'localStorage', // needed to avoid "login required" error
    storeAuthStateInCookie: false,
  },
  system: {
    tokenRenewalOffsetSeconds: 300 // Refresh tokens 5 minutes before expiry
  }
};

// MSAL App Instance
const msalPublicClientAppInstance = new PublicClientApplication(msalConfig);

export default msalPublicClientAppInstance;
